import { render, staticRenderFns } from "./NonAssignedApplicationReviewDetail.vue?vue&type=template&id=245a0401&scoped=true&"
import script from "./NonAssignedApplicationReviewDetail.vue?vue&type=script&lang=js&"
export * from "./NonAssignedApplicationReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./NonAssignedApplicationReviewDetail.vue?vue&type=style&index=0&id=245a0401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a0401",
  null
  
)

export default component.exports